import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import { Layout, List, Typography, Tooltip, Button, Divider, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import "leaflet/dist/leaflet.css";
import "antd/dist/reset.css";

const { Sider, Content } = Layout;
const { Text } = Typography;

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

function ClickHandler({ onMapClick }) {
  useMapEvents({
    click(e) {
      onMapClick(e.latlng);
    },
  });
  return null;
}

function RecenterMap({ position }) {
  const map = useMap();
  useEffect(() => {
    if (position) {
      map.setView([position.lat, position.lng], 10);
    }
  }, [position, map]);
  return null;
}

const Step5 = () => {
  const [markers, setMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);

  const addMarker = (latlng) => {
    const newMarker = {
      id: Date.now(),
      lat: latlng.lat,
      lng: latlng.lng,
    };
    setMarkers((prev) => [...prev, newMarker]);
  };

  const removeMarker = (id) => {
    setMarkers((prev) => prev.filter((marker) => marker.id !== id));
    if (selectedMarker?.id === id) setSelectedMarker(null);
  };

  return (
    <Layout style={{ height: "60vh" }}>      
      <Sider width={300} style={{ background: "#fff", padding: "0 10px" }}>
        <Typography.Title level={4}>📍 Ubicaciones</Typography.Title>
        <Divider />
        {markers.length === 0 ? (
          <Text type="secondary">Haz clic en el mapa para agregar una ubicación.</Text>
        ) : (
          <List
            dataSource={markers}
            renderItem={(marker) => (
              <List.Item
                style={{ cursor: "pointer", padding: "4px 0" }}
                onClick={() => setSelectedMarker(marker)}
                actions={[
                  <Tooltip title="Eliminar" key="delete">
                    <Button
                      shape="circle"
                      icon={<DeleteOutlined />}
                      danger
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeMarker(marker.id);
                      }}
                    />
                  </Tooltip>,
                ]}
              >
                <Space direction="vertical" size={0}>                  
                  <Text strong> {marker.lat.toFixed(4)}, {marker.lng.toFixed(4)}</Text>
                </Space>
              </List.Item>
            )}
          />
        )}
      </Sider>

      {/* Mapa */}
      <Content>
        <MapContainer center={[23.6345, -102.5528]} zoom={5} style={{ height: "100%", width: "100%" }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />
          <ClickHandler onMapClick={addMarker} />
          {markers.map((marker) => (
            <Marker key={marker.id} position={[marker.lat, marker.lng]} />
          ))}
          {selectedMarker && <RecenterMap position={selectedMarker} />}
        </MapContainer>
      </Content>
    </Layout>
  );
};

export default Step5;
